// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__lTK3Q","fullScreen":"style_fullScreen__r28Of","space":"style_space__3TIYV","hidden":"style_hidden___izVH"};